<div class="card" [ngClass]="{'cursor-pointer hover' : link, 'shadow': shadow}">
  <div ngbDropdown [ngClass]="{'has-image': image, 'd-none' : !hasActions}">
    <button class="btn btn-circle btn-light float-end" ngbDropdownToggle><fa-icon [icon]="faEllipsisV"></fa-icon></button>
    <div ngbDropdownMenu #actionsWrapper>
      <ng-content></ng-content>
    </div>
  </div>
  @if (image) {
    <div class="card-header" [routerLink]="link" [style.backgroundImage]="'url(' + image + ')'"></div>
  }
  <div class="card-body" [routerLink]="link">
    @if (title) {
      <h5 class="card-title" [ngClass]="{'overflow-title': fixed}">{{title}}</h5>
    }
    @if (text) {
      <p class="card-text" [ngClass]="{'overflow-text': fixed}" [innerHTML]="text | excerpt"></p>
    }
    <ng-content select="[body]"></ng-content>
  </div>
</div>
